export default __webpack_public_path__ + "static/media/console.ed8bf7db.svg";